<template>
  <fn-choices
    :id="id"
    :label="labelVisible ? $t('product.amount') : null"
    :options="options"
    :value="value"
    @update:value="updateValue"
  >
    <template #handle="{ label, selectedOption }">
      <strong class="hide-s">{{ label }}{{ ' ' }}</strong>
      <span v-if="selectedOption">{{ selectedOption.label }}</span>
    </template>
  </fn-choices>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    max: {
      type: Number,
      default: 10,
    },
    value: {
      type: [String, Number, Array],
      required: true,
    },
    labelVisible: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:value', 'input'],
  computed: {
    options() {
      const options = [];

      for (let i = 1; i <= this.max; i += 1) {
        options.push({
          value: i,
          label: `${i}x`,
        });
      }

      return options;
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('update:value', value);
      this.$emit('input', value);
    },
  },
};
</script>
